import Immutable from "immutable";
import { COLLECTION_SHAPE } from "../../../config/shapes";
import {
  FLAG_GETTING_REGISTERED_BUS_FLEETS,
  GET_REGISTERED_BUS_FLEETS,
  CLEAR_REGISTERED_BUS_FLEETS,
  GET_CURRENT_STATUS_REGISTERED_BUS_FLEETS,
  CLEAR_CURRENT_STATUS_REGISTERED_BUS_FLEETS,
  FLAG_GETTING_CURRENT_STATUS_REGISTERED_BUS_FLEETS,
  FLAG_BUS_RETENTION_SCHEDULE_ACTIVITY
} from '../../../actions/types';

const INITIAL_STATE = Immutable.Map({
  all: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    loading: false,
  }),
  currentStatus: Immutable.Map({
    content: Immutable.Map({}),
    loading: false,
  }),
  retention: Immutable.Map({
    activity: Immutable.List(),
  }),
})

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case FLAG_GETTING_REGISTERED_BUS_FLEETS:
      return state.setIn(['all', 'loading'], payload);
    case GET_REGISTERED_BUS_FLEETS:
      return state.setIn(['all', 'content'], Immutable.Map(payload));
    case CLEAR_REGISTERED_BUS_FLEETS:
      return INITIAL_STATE;
    case GET_CURRENT_STATUS_REGISTERED_BUS_FLEETS:
      return state.setIn(['currentStatus', 'content'], Immutable.Map(payload));
    case CLEAR_CURRENT_STATUS_REGISTERED_BUS_FLEETS:
      return state.setIn(['currentStatus', 'content'], Immutable.Map({}));
    case FLAG_GETTING_CURRENT_STATUS_REGISTERED_BUS_FLEETS:
      return state.setIn(['currentStatus', 'loading'], payload);
    case FLAG_BUS_RETENTION_SCHEDULE_ACTIVITY:
      if (payload) {
        return state.setIn(
          ['retention', 'activity'],
          state.getIn(['retention', 'activity']).push(payload),
        );
      }

      return state.setIn(
        ['retention', 'activity'],
        state.getIn(['retention', 'activity']).pop(),
      );
    default:
      return state;
  }
}
